export const referralAgencies = [
  'Louisiana Small Business Development Center',
  'U.S. Commercial Service',
  'Louisiana Economic Development Growth Network',
  'Other'
]

export const primaryActivityTypes = [
  'Distributor',
  'Manufacturing',
  'Service Company',
  'Other'
];

export const primaryAffiliationTypes = [
  { name: 'Aerospace', value: 'Aerospace' },
  { name: 'Apparel/Textile', value: 'Apparel/Textile' },
  { name: 'Automotive', value: 'Automotive' },
  { name: 'Boating/Marine', value: 'Boating/Marine' },
  { name: 'Defense', value: 'Defense' },
  { name: 'Energy', value: 'Energy' },
  { name: 'Food Products', value: 'Food Products' },
  { name: 'Furniture', value: 'Furniture'},
  { name: 'Green Technology', value: 'Green Technology' },
  { name: 'Info/Communication Technology', value: 'Info/Communication Technology' },
  { name: 'Life Sciences/Bio Tech', value: 'Life Sciences/Bio Tech' },
  { name: 'Lumber', value: 'Lumber' },
  { name: 'Plastics', value: 'Plastics' },
  { name: 'Security', value: 'Security' },
  { name: 'Other', value: 'Other' }
]

export const businessTypes = [
  { name: 'Rural-based Business', value: 'Rural-based Business' },
  { name: 'Veteran-owned Business', value: 'Veteran-owned Business' },
  { name: 'Woman-owned Business (At least 51% share)', value: 'Woman-owned Business (At least 51% share)' }, 
  { name: 'Service-connected Disabled Veteran-owned Business', value: 'Service-connected Disabled Veteran-owned Business' },
  { name: 'N/A', value: 'N/A' }
]

export const approxGrossSales = [
  '< $1.0 million',
  '$1 million - $5 million',
  '$6 million - $10 million',
  '$11 million - $20 million',
  '$21 million - $100 million',
  '> $100 million'
]

export const approxPercentageExport = [
  '0%',
  '1% - 5%',
  '6% - 10%',
  '11% - 25%',
  '26% - 50%',
  '> 50%',
  'Not exporting/New to exports'
]

export const usOriginContacts = [
  'Larry Collins',
  'Ben Fontenot',
  'Jessica Steverson',
  'Courtney Maciasz',
  'Abigail Depino'
]

export const fedOrgs = [
  { name: 'Department of Agriculture', value: 'Department of Agriculture' },
  { name: 'SBDC', value: 'SBDC' },
  { name: 'US Commercial Service', value: 'US Commercial Service' },
  { name: 'SBA', value: 'SBA' },
  { name: 'Other', value: 'Other' } 
]
